import React from 'react';
import moment from 'moment';
import PropTypes from 'prop-types';
import { Form, Input, Switch, DatePicker } from 'antd';

const { TextArea } = Input;
const formItemLayout = {
  labelCol: {
    sm: { span: 6 },
  },
  wrapperCol: {
    sm: { span: 16 },
  },
};

const FormItem = Form.Item;

function UpdateForm({ form, item: { title, status, desc, timeout } }) {
  const { getFieldDecorator } = form;
  return (
    <Form>
      <FormItem label="标题" {...formItemLayout}>
        {getFieldDecorator('title', {
          rules: [{ required: true, message: '请输入标题' }],
          initialValue: title,
        })(<Input />)}
      </FormItem>
      <FormItem label="描述" {...formItemLayout}>
        {getFieldDecorator('desc', {
          initialValue: desc,
        })(<TextArea rows="3" />)}
      </FormItem>
      <FormItem label="有效期" {...formItemLayout}>
        {getFieldDecorator('timeout', {
          rules: [{ required: true, message: '请选择有效期' }],
          initialValue: timeout ? moment(timeout) : moment().add(20, 'years'),
        })(<DatePicker style={{ width: '100%' }} />)}
      </FormItem>
      <FormItem label="是否启用" {...formItemLayout}>
        {getFieldDecorator('status', {
          initialValue: status ? status === 'on' : true,
        })(<Switch defaultChecked={status ? status === 'on' : true} />)}
      </FormItem>
    </Form>
  );
}

UpdateForm.propTypes = {
  form: PropTypes.shape().isRequired,
  item: PropTypes.shape().isRequired,
};

export default Form.create()(UpdateForm);
